import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import { getVisibleSections, QUICK_LAUNCH } from "../../lib/windowManager/registry";
import { Sun, Moon, LogOut } from "lucide-react";

export default function StartMenu({ onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAdmin, canEdit, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();

  const sections = getVisibleSections(isAdmin);

  function go(route) {
    if (route !== location.pathname) navigate(route);
    onClose();
  }

  function handleLogout() {
    onClose();
    logout();
    navigate("/login");
  }

  return (
    <div className="win98-start-menu win-window" role="menu" aria-label="Start menu">
      <div className="win98-start-header">
        <span className="win98-start-header-name">{user?.name || "User"}</span>
        <span className="win98-start-header-role">{user?.role}</span>
      </div>
      <div className="win98-start-menu-list">
        {canEdit && (
          <>
            {QUICK_LAUNCH.map((entry) => (
              <button
                key={entry.id}
                type="button"
                role="menuitem"
                className="win98-start-menu-item"
                onClick={() => go(entry.route)}
              >
                <span aria-hidden="true">{entry.icon}</span>
                {entry.title}
              </button>
            ))}
            <div className="win-divider win98-start-divider" />
          </>
        )}
        {sections.map((entry) => (
          <button
            key={entry.id}
            type="button"
            role="menuitem"
            className="win98-start-menu-item"
            onClick={() => go(entry.route)}
          >
            <span aria-hidden="true">{entry.icon}</span>
            {entry.title}
          </button>
        ))}
        <div className="win-divider win98-start-divider" />
        <button type="button" role="menuitem" className="win98-start-menu-item" onClick={toggleTheme}>
          {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          {theme === "dark" ? "Light Win98" : "Dark Win98"}
        </button>
        <button type="button" role="menuitem" className="win98-start-menu-item" onClick={handleLogout}>
          <LogOut className="w-4 h-4" />
          Log Off {user?.name ? user.name.split(" ")[0] : ""}
        </button>
      </div>
    </div>
  );
}
